import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { StepStatus, StepProps } from "../../../../../common/types/Stepper";
import _ from 'lodash';
import { userStyles } from '../../../../styles';
import { contentRequestAccordianActions } from '../../../../reducers/contentRequestAccordianState';
import MyPATExpansionStep from "../../../../../common/MyPATExpansionStep";
import { MyPATLocalLoader } from '../../../../../common';
import QuestionCard from '../../../../components/QuestionCard';
import SelectWithContent from '../../SelectWithContent';
import contentRequestServices from '../../../../services/contentRequestServices';
import Progress from '../ProgressBar';
import { Grid, Checkbox, Modal, WithStyles, withStyles, Button } from '@material-ui/core';
import { selectAllCheckbox, setQuestionTabDetails, setSelectedQuestionsBySelectAll, setResetQuestionsBySelectAll, setSelectAll } from '../../../../../mylibrary/reducers/bulkimportReducer';
import { getSyllabusRenderValue } from '../../../../../../utils';
import { getTypeOfGoal, getSubject } from '../../../../../test-template/actions/testTemplateActions';
import { testTemplateService } from '../../../../../test-template/services/testTemplateService';
import CustomInfoIcon from '../../../../../common/CustomInfoIcon';
import { showMsg } from '../../../../../user-management/actions/miniLibrariesActions';
import RequestReviewContainer from '../../../RequestReviewContainer';
import { withRouter } from 'react-router-dom';


interface QuestionComponentProps extends WithStyles<typeof userStyles> {
    expansionRoot?: any,
    questionData: any,
    requestId: string,
    history: any,
    selectAllArray: any,
    selectedQuestionCount: number,
    checkboxDisable: boolean,
    setAccordianState: Function,
    accordianState: any,
    accordianTouched: any,
    setAccordingTouchIndex: Function,
    setAccordianTouchWhileCreate: Function,
    accordianCreateTouched: any,
    handleChooseFromLibrary: Function,
    isComingFromQuestionComponent: boolean,
    isTabOpened: boolean,
    setIsTabOpened: Function,
    progressBarForQuestion: any,
    contentRequestId: string,
    testDetails: any,
    totalCount: number,
    setTestAccordian: Function,
    accordianTest: any,
    subHeading: string,
    type: string,
    bulkImportCount: number,
    selectAllCheckbox: any,
    contentRequestData: any,
    setQuestionTabDetails: any,
    isTestRequest: boolean,
    contentRequestQuestionId: string,
    setProgressBarForQuestion: Function,
    setFilterQuestionArray: Function,
    contentRequestItemsIdForFirstTime: any,
    filteredQuestionArray: any,
    showMsg: any,
    setSelectedQuestionsBySelectAll: any,
    selectedQuestionsBySelectAll: any,
    manuallySelectedBulkQuestions: any,
    getTypeOfGoal: Function,
    getGoals: any,
    getSubject: any,
    getSubjects: any,
    setResetQuestionsBySelectAll: any,
    resetQuestionsBySelectAll: any,
    setSelectAll: Function,
    selectAll: any,
    checkAll: any,
    questionTabDetails: any,
    overallDone: boolean;
    totalUnresolvedCount: number;
    removeUnresolvedFeedbackCount: any;
    match: any;
    setFeedbackClose: Function
}
interface QuestionComponentState {
    accordianTouchState: any,
    selectAllArray: any,
    selectedQuestionsBySelectAllCount: number,
    accordianCreateTouched: any,
    preSelectedFilterContent: any,
    selectQuestionDialogOpen: boolean,
    checkAll: any,
    selectAll: boolean,
    questionTabDetails: any,
    questionId: string,
    contentRequestItemsId: any,
    selectedQuestionCount: number,
    checkboxDisable: boolean,
    code: any,
    accordianBulkIndex: number,
    selectAllData: any,
    selectAllCheck: boolean,
    passage: any
    showRequestContainer: boolean;
    sliderData: any;
    selectedContentId: string,
    currentQuestionNumber: number,
    currentTestNumber: number,
    contentQuestionType: string,
    contentQuestionCode: string,
    fromURL: string,
    isUnresolvedCount: boolean,
    unresolvedFeedbackCount: number,
    loading: boolean;
}
enum FilterValues {
    status = 'status',
    published = 'PUBLISHED',
    contentType = 'contentType',
    question = 'question',
    MMCQ = 8
}

class QuestionComponent extends Component<QuestionComponentProps, QuestionComponentState> {
    constructor(props: QuestionComponentProps) {
        super(props);
        this.state = {
            selectAllArray: [],
            checkboxDisable: false,
            selectedQuestionCount: 0,
            checkAll: {},
            selectAllCheck: false,
            selectedQuestionsBySelectAllCount: 0,
            selectAll: false,
            questionTabDetails: [],
            accordianTouchState: [...this.props.accordianTouched],
            accordianCreateTouched: { ...this.props.accordianCreateTouched },
            preSelectedFilterContent: {
                contentMenu: "createdbyme",
                goalsDriller: {},
                contentFilterData: [{
                    filterValue: FilterValues.contentType,
                    isSelected: true,
                    disabled: false,
                    filters: [{
                        filterValue: FilterValues.question,
                        isSelected: true,
                        disabled: false,
                        filters: [{
                            filterValue: FilterValues.MMCQ,
                            isSelected: true,
                            filters: [],
                        }]
                    }
                    ]
                },
                {
                    filterValue: FilterValues.status,
                    isSelected: true,
                    filters: [{
                        filterValue: "PUBLISHED",
                        isSelected: true,
                        filters: []
                    }],
                }
                ]
            },
            selectQuestionDialogOpen: false,
            questionId: '',
            accordianBulkIndex: 0,
            contentRequestItemsId: {},
            code: '',
            selectAllData: [],
            passage: {},
            showRequestContainer: false,
            sliderData: {},
            selectedContentId: '',
            currentQuestionNumber: 1,
            currentTestNumber: 1,
            contentQuestionType: '',
            contentQuestionCode: '',
            fromURL: 'preview',
            isUnresolvedCount: false,
            unresolvedFeedbackCount: 0,
            loading: true,
        }
        this.contentChanged = this.contentChanged.bind(this);
        this.closeReviewContainer = this.closeReviewContainer.bind(this);
        // const selectedQu/estionCount : any;
    }
    isCount = (count: number) => {
        if (count === 0)
            return false
        else
            return true
    }
    handleLoader = () => {
        this.setState({
            loading: false,
        })
    }
    componentDidMount = () => {
        this.props.getTypeOfGoal();
        this.props.getSubject();
        setTimeout(() => {
            const { accordianTouched = [], checkAll = [] } = this.props;
            let maintainCheckState: any = [];
            maintainCheckState = [...checkAll];
            accordianTouched && accordianTouched.length && accordianTouched.map((val: any, accordianIndex: number) => {
                const { questionContent = [] } = accordianTouched[accordianIndex];
                let questionCheck: any = {}
                let disabledCheck: any = {}
                questionContent && questionContent.length && questionContent.forEach((element: any) => {
                    questionCheck = { ...questionCheck, [`ACC${accordianIndex}${element.questionIndex}`]: false }
                    disabledCheck = { ...disabledCheck, [`ACCDISABLE${accordianIndex}${element.questionIndex}`]: element.attachedQuestions.contentId ? true : false };
                });
                maintainCheckState.push({ [`ACC${accordianIndex}`]: false, isSelected: false, [`questionCheck`]: { ...questionCheck }, ['disabledCheck']: { ...disabledCheck } });
            });
            this.props.selectAllCheckbox({
                item: maintainCheckState
            });
            accordianTouched && accordianTouched.length && this.handleLoader();
        }, 1000);
    }


    handleQuestionState = (index: number, accordianIndex: number) => {
        const accordianState = accordianIndex;
        const questionIndex = index + 1;
        let contentId = '';
        let content_Id = '';
        this.setState({
            accordianCreateTouched: {
                accordianIndex: accordianState,
                questionIndex: questionIndex
            }
        }, () => {
            const { setAccordianTouchWhileCreate } = this.props;
            const { accordianCreateTouched = {} } = this.state;
            setAccordianTouchWhileCreate(accordianCreateTouched)
        });
    }
    handleChooseFromLibrary = async (questionIndex: number, accordianIndex: number, questionId: any, contentRequestItemsId: any, code: any, accordianCreateTouched: any, questionData: any, passage: any) => {
        const { preSelectedFilterContent } = this.state;
        const { contentRequestData = {} } = this.props;
        const { requestInfo: { details: { courseTypes = [] } = {} } = {} } = contentRequestData;
        let driller = {};
        if (questionData) {
            const { syllabus: { subjects = [] } = {} } = questionData;
            let courses = courseTypes && courseTypes.length && courseTypes[0];
            const overAllCourse = this.props.getGoals.filter((ele: any) => ele.courseType.id === courses.id);
            let course: any = {
                ...overAllCourse[0]
            }

            const subject = subjects && subjects.length && subjects[0].subjectId;
            const res = await testTemplateService.getAllSyllabus(overAllCourse[0]._id, "subject");
            const subjectData = res.filter((ele: any) => ele.masterIDs.includes(subject._id));
            const subjectsData = {
                _id: subjectData.length ? subjectData[0]._id : subject._id,
                name: subjectData.length ? subjectData[0].name : subject.name
            }
            let goalsDrillers = {
                level: 'course',
                course: { ...course },
                subject: { ...subjectsData },
                // subSubject: { ...subSubject },
                // class: { ...classId }
            };
            driller = { ...goalsDrillers };
        }

        let preFilters: any = { ...preSelectedFilterContent };
        preFilters['contentFilterData'][0]['filters'][0]['filters'] = [{
            filterValue: Number(code),
            isSelected: true,
            filters: [],
        }];
        this.setState({
            selectQuestionDialogOpen: !this.state.selectQuestionDialogOpen,
            accordianCreateTouched: {
                questionIndex,
                accordianIndex,
            },
            questionId,
            contentRequestItemsId,
            preSelectedFilterContent: { ...preFilters, goalsDriller: { ...driller } },
            code,
            passage
        });

    }
    handleChooseFromLibraryForUnresolvedContent = async (questionIndex: number, accordianIndex: number, questionId: any, contentRequestItemsId: any, code: any, accordianCreateTouched: any, questionData: any, passage: any, unresolvedFeedbackCount?: number) => {
        const { preSelectedFilterContent } = this.state;
        const { contentRequestData = {} } = this.props;
        const { requestInfo: { details: { courseTypes = [] } = {} } = {} } = contentRequestData;
        let driller = {};
        if (questionData) {
            const { syllabus: { subjects = [] } = {} } = questionData;
            let courses = courseTypes && courseTypes.length && courseTypes[0];
            const overAllCourse = this.props.getGoals.filter((ele: any) => ele.courseType.id === courses.id);
            let course: any = {
                ...overAllCourse[0]
            }

            const subject = subjects && subjects.length && subjects[0].subjectId;
            const res = await testTemplateService.getAllSyllabus(overAllCourse[0]._id, "subject");
            const subjectData = res.filter((ele: any) => ele.masterIDs.includes(subject._id));
            const subjectsData = {
                _id: subjectData.length ? subjectData[0]._id : subject._id,
                name: subjectData.length ? subjectData[0].name : subject.name
            }
            const subSubject = subjects && subjects.length && subjects[0].subSubjects[0].subSubjectId
            let goalsDrillers = {
                level: 'course',
                course: { ...course },
                subject: { ...subjectsData },
                // subSubject: { ...subSubject },
                // class: { ...classId }
            };
            driller = { ...goalsDrillers };
        }

        let preFilters: any = { ...preSelectedFilterContent };
        preFilters['contentFilterData'][0]['filters'][0]['filters'] = [{
            filterValue: Number(code),
            isSelected: true,
            filters: [],
        }];
        this.setState({
            selectQuestionDialogOpen: !this.state.selectQuestionDialogOpen,
            accordianCreateTouched: {
                questionIndex,
                accordianIndex,
            },
            questionId,
            contentRequestItemsId,
            preSelectedFilterContent: { ...preFilters, goalsDriller: { ...driller } },
            code,
            passage,
            isUnresolvedCount: true,
            unresolvedFeedbackCount: unresolvedFeedbackCount ? unresolvedFeedbackCount : 0
        });

    }


    importQuestion = async (contentRequestItemsId: any, questionId: any, questionCode: string, questionData: any, passage: any, unresolvedFeedbackCount?: number) => {
        const { preSelectedFilterContent } = this.state;
        let preFilters: any = { ...preSelectedFilterContent };
        const { contentRequestData = {} } = this.props;
        const { requestInfo: { details: { courseTypes = [] } = {} } = {} } = contentRequestData;
        let driller = {};
        if (questionData) {
            const { syllabus: { subjects = [] } = {} } = questionData;
            let courses = courseTypes && courseTypes.length && courseTypes[0];
            const overAllCourse = this.props.getGoals.filter((ele: any) => ele.courseType.id === courses.id);
            let course: any = {
                _id: overAllCourse[0]._id,
                name: overAllCourse[0].name
            }

            const subject = subjects && subjects.length && subjects[0].subjectId;
            const res = await testTemplateService.getAllSyllabus(overAllCourse[0]._id, "subject");
            const subjectData = res.filter((ele: any) => ele.masterIDs.includes(subject._id));
            const subjectsData = {
                _id: subjectData.length ? subjectData[0]._id : subject._id,
                name: subjectData.length ? subjectData[0].name : subject.name
            }
            // const subSubject = subjects && subjects.length && subjects[0].subSubjects[0].subSubjectId
            // const classId = subjects && subjects.length && subjects[0].subSubjects[0].chapters[0].concepts[0].classId;
            let goalsDrillers = {
                level: 'course',
                course: { ...course },
                subject: { ...subjectsData },
            };
            driller = { ...goalsDrillers };
        }
        preFilters['contentFilterData'][0]['filters'][0]['filters'] = [{
            filterValue: Number(questionCode),
            isSelected: true,
            filters: [],
        }];
        this.setState({
            contentRequestItemsId,
            questionId,
            selectQuestionDialogOpen: !this.state.selectQuestionDialogOpen,
            preSelectedFilterContent: { ...preFilters, goalsDriller: { ...driller } },
            code: questionCode,
            passage,
            isUnresolvedCount: unresolvedFeedbackCount ? true : false,
            unresolvedFeedbackCount: unresolvedFeedbackCount ? 1 : 0
        })
    }

    isQuestionResetable = async () => {
        const { match } = this.props;
        const { params: { contentRequestId = '', role = '' } = {} } = match;
        const result = await contentRequestServices.getOwnerTaskByRole(contentRequestId, role)
        const { requestInfo: { type = '', details = {} } = {} } = result;
        return this.checkIfSubmitForEvalutionIsDone(details);
    }

    checkIfSubmitForEvalutionIsDone = (details: any) => {
        const { subjects = [] } = details;
        let questionsData: any = [];
        let checkOverAllCreatorStatus = 0;
        subjects &&
            subjects.length &&
            subjects.map((val: any) => {
                const { questions = [] } = val;
                questions.map((val: any) => {
                    questionsData.push(val);
                });
            });
        questionsData.forEach((question: any) => {
            const { contentRequestItemsId = {} } = question;
            if (contentRequestItemsId) {
                const { overallStatus: {
                    creator: {
                        isJobCompleted = false
                    } = {}
                } = {} } = contentRequestItemsId;
                if (isJobCompleted) {
                    checkOverAllCreatorStatus++;
                }
            }
        });
        return checkOverAllCreatorStatus === questionsData.length;

    }

    handleResetQuestion = async (resetIndexQuestion: number, resetIndexAccordian: number, contentRequestItemsId: string) => {
        const isQuestionResetable = await this.isQuestionResetable();
        if (!isQuestionResetable) {
            const { accordianTouched, setAccordingTouchIndex, setProgressBarForQuestion, progressBarForQuestion, filteredQuestionArray, setFilterQuestionArray } = this.props;
            let newAccordianTouchState = [...accordianTouched];
            const { questionContent = [] } = newAccordianTouchState[resetIndexAccordian];
            let updateQuestionContent = [...questionContent];
            let getCheckBoxValue = [...this.props.checkAll];
            const findQuestionIndex = questionContent.findIndex((ele: any) => ele.questionIndex === resetIndexQuestion);
            const contentID = updateQuestionContent[findQuestionIndex].attachedQuestions.content_Id.substring(0, 24);
            const questionId = updateQuestionContent[findQuestionIndex].attachedQuestions.contentId.substring(0, 24);
            const newFilteredArray = filteredQuestionArray.filter((ele: any) => ele.contentId !== questionId)
            try {
                const saveResponse = contentRequestServices.resetQuestions(contentRequestItemsId, contentID);

            } catch (error) {
            };
            const isJobDoneForQuestion = updateQuestionContent[findQuestionIndex].attachedQuestions.isJobCompleted;
            updateQuestionContent[findQuestionIndex] = {
                ...updateQuestionContent[findQuestionIndex],
                attachedQuestions: {
                    contentId: '',
                    content_Id: '',
                    isJobCompleted: false,
                    isTouched: true,
                }
            }
            newAccordianTouchState[resetIndexAccordian] = {
                ...newAccordianTouchState[resetIndexAccordian],
                questionContent: [
                    ...updateQuestionContent,
                ]
            }
            getCheckBoxValue[resetIndexAccordian] = {
                ...getCheckBoxValue[resetIndexAccordian],
                ['questionCheck']: {
                    ...getCheckBoxValue[resetIndexAccordian]['questionCheck'],
                    [`ACC${resetIndexAccordian}${resetIndexQuestion}`]: false
                },
                [`disabledCheck`]: {
                    ...getCheckBoxValue[resetIndexAccordian]['disabledCheck'],
                    [`ACCDISABLE${resetIndexAccordian}${resetIndexQuestion}`]: false
                }
            }
            const { count } = progressBarForQuestion;
            setAccordingTouchIndex(newAccordianTouchState);
            setFilterQuestionArray(newFilteredArray);
            this.props.selectAllCheckbox({
                item: [...getCheckBoxValue]
            })
            isJobDoneForQuestion && setProgressBarForQuestion({ count: count - 1 });
            return true;
        } else {
            // console.log(':::::::::::::::You Cannot Reset Question:::::::::');
            this.props.showMsg('Cannot add Question', 'error');
            return false;
        }
    }

    handleResetQuestionForUnresolvedCount = (resetIndexQuestion: number, resetIndexAccordian: number, contentRequestItemsId: string, unresolvedFeedbackCount?: number) => {
        const { accordianTouched, setAccordingTouchIndex, setProgressBarForQuestion, progressBarForQuestion, filteredQuestionArray, setFilterQuestionArray } = this.props;
        let newAccordianTouchState = [...accordianTouched];
        const { questionContent = [] } = newAccordianTouchState[resetIndexAccordian];
        let updateQuestionContent = [...questionContent];
        let getCheckBoxValue = [...this.props.checkAll];
        const findQuestionIndex = questionContent.findIndex((ele: any) => ele.questionIndex === resetIndexQuestion);
        const contentID = updateQuestionContent[findQuestionIndex].attachedQuestions.content_Id.substring(0, 24);
        const questionId = updateQuestionContent[findQuestionIndex].attachedQuestions.contentId.substring(0, 24);
        const newFilteredArray = filteredQuestionArray.filter((ele: any) => ele.contentId !== questionId)
        // try {
        //     const saveResponse = contentRequestServices.resetQuestions(contentRequestItemsId, contentID);

        // } catch (error) {
        // };
        const isJobDoneForQuestion = updateQuestionContent[findQuestionIndex].attachedQuestions.isJobCompleted;
        const previousVersion = Object.keys(updateQuestionContent[findQuestionIndex]['attachedQuestions'].previousVersion).length ?
        updateQuestionContent[findQuestionIndex]['attachedQuestions'].previousVersion : updateQuestionContent[findQuestionIndex]['attachedQuestions']
        updateQuestionContent[findQuestionIndex] = {
            ...updateQuestionContent[findQuestionIndex],
            attachedQuestions: {
                contentId: '',
                content_Id: '',
                isJobCompleted: false,
                isTouched: true,
                unresolvedFeedbackCount: unresolvedFeedbackCount,
                previousVersion: {
                  ...previousVersion  
                }
            }
        }
        newAccordianTouchState[resetIndexAccordian] = {
            ...newAccordianTouchState[resetIndexAccordian],
            questionContent: [
                ...updateQuestionContent,
            ]
        }
        getCheckBoxValue[resetIndexAccordian] = {
            ...getCheckBoxValue[resetIndexAccordian],
            ['questionCheck']: {
                ...getCheckBoxValue[resetIndexAccordian]['questionCheck'],
                [`ACC${resetIndexAccordian}${resetIndexQuestion}`]: false
            },
            [`disabledCheck`]: {
                ...getCheckBoxValue[resetIndexAccordian]['disabledCheck'],
                [`ACCDISABLE${resetIndexAccordian}${resetIndexQuestion}`]: false
            }
        }
        const { count } = progressBarForQuestion;
        setAccordingTouchIndex(newAccordianTouchState);
        // setFilterQuestionArray(newFilteredArray);
        this.props.selectAllCheckbox({
            item: [...getCheckBoxValue]
        })
        isJobDoneForQuestion && setProgressBarForQuestion({ count: count - 1 });
    }

    handleSaveQuestion = (questionIndex: number, accordianIndex: number, code: string) => {
        const { accordianTouched, setAccordingTouchIndex, setProgressBarForQuestion, progressBarForQuestion } = this.props;
        let newAccordianTouchState = [...accordianTouched];
        const { questionContent = [] } = newAccordianTouchState[accordianIndex];
        let updateQuestionContent = [...questionContent];
        const findQuestionIndex = questionContent.findIndex((ele: any) => ele.questionIndex === questionIndex);
        if (code === '5') {
            updateQuestionContent[findQuestionIndex] = {
                ...updateQuestionContent[findQuestionIndex],
                attachedQuestions: {
                    ...updateQuestionContent[findQuestionIndex]['attachedQuestions'],
                    isJobCompleted: true,
                    isTouched: true,
                    unresolvedFeedbackCount: 0
                }
            }
            newAccordianTouchState[accordianIndex] = {
                ...newAccordianTouchState[accordianIndex],
                questionContent: [
                    ...updateQuestionContent,
                ]
            }
        }
        else {
            updateQuestionContent[findQuestionIndex] = {
                ...updateQuestionContent[findQuestionIndex],
                attachedQuestions: {
                    ...updateQuestionContent[findQuestionIndex]['attachedQuestions'],
                    isJobCompleted: true,
                    isTouched: true,
                    unresolvedFeedbackCount: 0
                }
            }
            newAccordianTouchState[accordianIndex] = {
                ...newAccordianTouchState[accordianIndex],
                questionContent: [
                    ...updateQuestionContent,
                ]
            }
        }
        setAccordingTouchIndex(newAccordianTouchState);
    };

    handleSaveQuestionForUnresolvedContent = (questionIndex: number, accordianIndex: number, code: string) => {
        const { accordianTouched, setAccordingTouchIndex, setProgressBarForQuestion, progressBarForQuestion } = this.props;
        let newAccordianTouchState = [...accordianTouched];
        const { questionContent = [] } = newAccordianTouchState[accordianIndex];
        let updateQuestionContent = [...questionContent];
        const findQuestionIndex = questionContent.findIndex((ele: any) => ele.questionIndex === questionIndex);
        if (code === '5') {
            updateQuestionContent[findQuestionIndex] = {
                ...updateQuestionContent[findQuestionIndex],
                attachedQuestions: {
                    ...updateQuestionContent[findQuestionIndex]['attachedQuestions'],
                    isJobCompleted: true,
                    isTouched: true,
                    unresolvedFeedbackCount: 0
                }
            }
            newAccordianTouchState[accordianIndex] = {
                ...newAccordianTouchState[accordianIndex],
                questionContent: [
                    ...updateQuestionContent,
                ]
            }
        }
        else {
            updateQuestionContent[findQuestionIndex] = {
                ...updateQuestionContent[findQuestionIndex],
                attachedQuestions: {
                    ...updateQuestionContent[findQuestionIndex]['attachedQuestions'],
                    isJobCompleted: true,
                    isTouched: true,
                    unresolvedFeedbackCount: 0
                }
            }
            newAccordianTouchState[accordianIndex] = {
                ...newAccordianTouchState[accordianIndex],
                questionContent: [
                    ...updateQuestionContent,
                ]
            }
        }
        setAccordingTouchIndex(newAccordianTouchState);
        localStorage.setItem('overallData', 'true');
    }


    handleCheckboxState = (accordianIndex: number, questionIndex: number) => {
        const questionTabIndexes = {
            accordianIndex,
            questionIndex
        }
        let questionTabDetails: any = [...this.props.questionTabDetails];
        questionTabDetails = [...questionTabDetails, questionTabIndexes];
        let selectAllQuestion = this.props.checkAll[accordianIndex];
        const { questionCheck = [] } = selectAllQuestion;
        let keys = Object.keys(questionCheck);
        let count = 0;
        keys && keys.length && keys.forEach((ele) => {
            if (questionCheck[ele]) {
                count = count + 1;
            }
        })
        if (count === questionTabDetails.length) {
            this.props.setSelectedQuestionsBySelectAll({
                item: questionTabDetails
            });
        }
        this.props.setQuestionTabDetails({
            item: questionTabDetails
        });
    }

    HandleSelectAll = (accordianTouched: any, accordianIndex: any, event: any) => {
        if (!event) {
            this.props.setSelectedQuestionsBySelectAll({
                item: []
            })
        }
        else {
            let selectQuestion = [...accordianTouched]
            let selectedQuestionsBySelectAll = selectQuestion[accordianIndex][`questionContent`].map((element: any) => {
                if (!element.attachedQuestions.contentId)
                    return { accordianIndex, questionIndex: element.questionIndex }
            });
            selectedQuestionsBySelectAll = selectedQuestionsBySelectAll.filter((ele: any) => ele !== undefined);
            this.setState({
                accordianBulkIndex: accordianIndex,
                selectAllData: selectedQuestionsBySelectAll,
                selectedQuestionsBySelectAllCount: selectedQuestionsBySelectAll.length
            }, () => {
                this.props.setSelectedQuestionsBySelectAll({
                    item: this.state.selectAllData
                })
            })
        }
        this.props.setQuestionTabDetails({
            item: []
        })
    }

    removeSelectAll = () => {
        this.setState({
            selectedQuestionsBySelectAllCount: 0,
        })
    }

    removeQuestionFromCheckboxState = (accordianIndex: number, questionIndex: number) => {
        let newQuestionTabDetails = this.props.questionTabDetails.filter((questionDetail: any) => {
            return questionDetail.accordianIndex === accordianIndex && questionDetail.questionIndex !== questionIndex
        });
        let selectedQuestionsBySelectAll = [...this.props.selectedQuestionsBySelectAll];
        if (selectedQuestionsBySelectAll && selectedQuestionsBySelectAll.length) {
            let removeSelectedQuestion = selectedQuestionsBySelectAll.filter((ele: any) => !(ele.accordianIndex === accordianIndex && ele.questionIndex === questionIndex));
            this.props.setSelectedQuestionsBySelectAll({
                item: []
            })
            this.props.setQuestionTabDetails({
                item: [...removeSelectedQuestion]
            });
        } else {
            this.props.setQuestionTabDetails({
                item: [...newQuestionTabDetails]
            });
        }
    }

    addQuestions = (count: number, code: string, accordianIndex: number, contentRequestItemsId: any, questionId: string, questionData: any) => {
        const { requestId, history, accordianTouched, contentRequestId, type, accordianState, contentRequestData } = this.props;
        const { questionContent } = accordianTouched[accordianIndex];
        let stringCheck = 0;

        const filterContent = questionContent.filter((ele: any) => ele.attachedQuestions.isJobCompleted)
        questionContent && questionContent.map((element: any) => {
            const { questionIndex = 0, attachedQuestions = {} } = element;

            if (attachedQuestions.contentId !== "") {
                stringCheck = 1;
            }


        })
        const { passage = [] } = accordianState[accordianIndex];
        const passageData = passage;
        let contentRequestItemId = !accordianState[accordianIndex].contentRequestItemsId ? this.props.contentRequestItemsIdForFirstTime : accordianState[accordianIndex].contentRequestItemsId._id;

        return questionContent && questionContent.map((element: any, index: number) => {
            const { questionIndex = 0, attachedQuestions = {} } = element;
            let passageDetail = accordianState[accordianIndex].passage[index];
            let checkboxVisiblity = (stringCheck === 1 || filterContent.length > 0 ? true : false);
            return (
                <div>
                    <QuestionCard selectAll={this.state.selectAll} checkboxVisiblity={checkboxVisiblity} checkboxDisable={attachedQuestions.contentId ? true : false}
                        removeQuestionFromCheckboxState={() => { this.removeQuestionFromCheckboxState(accordianIndex, questionIndex) }} questionId={questionId}
                        accordianIndex={accordianIndex}
                        handleCheckboxState={() => { this.handleCheckboxState(accordianIndex, questionIndex) }} type={type} count={questionIndex}
                        attachedQuestions={attachedQuestions} code={code} requestId={requestId} contentRequestItemsId={contentRequestItemsId}
                        handleQuestionState={() => this.handleQuestionState(questionIndex - 1, accordianIndex)} history={history}
                        handleChooseFromLibrary={() => this.handleChooseFromLibrary(questionIndex, accordianIndex, questionId, contentRequestItemsId, code, accordianTouched, questionData, passageData)}
                        handleReset={() => { this.handleResetQuestion(questionIndex, accordianIndex, contentRequestItemId) }}
                        accordianState={accordianState} contentRequestData={contentRequestData} passageDetail={passageDetail}
                        handleSaveQuestion={() => this.handleSaveQuestion(questionIndex, accordianIndex, code)}
                        handleSaveQuestionForUnresolvedContent={() => this.handleSaveQuestionForUnresolvedContent(questionIndex, accordianIndex, code)}
                        contentRequestId={contentRequestData._id}
                        questionIndex={questionIndex}
                        handleResetQuestionForUnresolvedCount={() => this.handleResetQuestionForUnresolvedCount(questionIndex, accordianIndex, contentRequestItemId, attachedQuestions.unresolvedFeedbackCount)}
                        handleChooseFromLibraryForUnresolvedContent={() => this.handleChooseFromLibraryForUnresolvedContent(questionIndex, accordianIndex, questionId, contentRequestItemsId, code, accordianTouched, questionData, passageData, attachedQuestions.unresolvedFeedbackCount)}
                    />
                </div>
            )
        })
    }

    handleCountOfSelectedQuestions = (selectedQuestionsBySelectAll: any, manuallySelectedQuestions: any) => {
        if (selectedQuestionsBySelectAll.length)
            return selectedQuestionsBySelectAll[0].accordianIndex
        else if (manuallySelectedQuestions.length)
            return manuallySelectedQuestions[0].accordianIndex
        else
            return false
    }

    onFeedbackClickFromCreator(question: any) {
        let unResolvedContent = JSON.parse(JSON.stringify(question.contentRequestItemsId));
        let unResolvedCountData = unResolvedContent.contents.filter((ele: any) => ele.content_id.unresolvedFeedbackCount > 0);
        unResolvedContent.contents = unResolvedCountData;
        this.setState({
            showRequestContainer: true,
            sliderData: unResolvedContent,
            selectedContentId: `${unResolvedContent.contents[0].content_id._id}question`,
            contentQuestionType: 'question',
            contentQuestionCode: question.code
        })
    }

    getCount = (values: any, accordianIndex: number, selectAll: any) => {
        let count = 0
        if (values && values[accordianIndex]) {
            Object.keys(values[accordianIndex][`questionCheck`]).map((element: any, index: number) => {
                if (values[accordianIndex][`questionCheck`][element] && !values[accordianIndex][`disabledCheck`][`ACCDISABLE${accordianIndex}${index + 1}`]) {
                    count = count + 1;
                }
            });
            if (selectAll[`ACC${accordianIndex}`]) {
                return `SelectAll`
            } else if (!selectAll[`ACC${accordianIndex}`] && !count) {
                return `SelectAll`;
            } else {
                return `${count} Selected`;
            }
        }
    }

    bulkImportButton = (contentRequestItemsId: any, accordianTouched: any, accordianIndex: number, questionId: string, questionCode: string, questionData: any, passage: any) => {
        const { bulkImportCount, checkAll } = this.props;

        return (

            <Grid
                container
                spacing={8}
                alignItems="center"
                justify="space-between"
                wrap="nowrap"
            >
                {
                    (
                        <Grid item>
                            <Checkbox
                                checked={(this.props.selectAll[`ACC${accordianIndex}`] && Object.keys(this.props.selectAll).length) ? true : false}
                                color="primary"
                                onClick={(event: any) => {
                                    this.setState({
                                        selectedQuestionsBySelectAllCount: event.target.checked ? this.state.selectedQuestionsBySelectAllCount : 0,
                                    },
                                        () => {
                                            if (!this.props.selectAll[`ACC${accordianIndex}`]) {
                                                let checkValueForSelectedPart = [...this.props.checkAll];
                                                let { questionCheck = {} } = checkValueForSelectedPart[accordianIndex];
                                                let { disabledCheck = {} } = checkValueForSelectedPart[accordianIndex];
                                                let cloneQuestionCheck = { ...questionCheck };
                                                cloneQuestionCheck && Object.keys(cloneQuestionCheck).map((key: any, index: number) => {
                                                    if (!disabledCheck[`ACCDISABLE${accordianIndex}${index + 1}`]) {
                                                        cloneQuestionCheck[key] = true;
                                                    }
                                                });
                                                checkValueForSelectedPart[accordianIndex] = {
                                                    ...checkValueForSelectedPart[accordianIndex],
                                                    isSelected: true,
                                                    questionCheck: { ...cloneQuestionCheck }
                                                };
                                                this.props.selectAllCheckbox({
                                                    item: [...checkValueForSelectedPart]
                                                })
                                                this.HandleSelectAll(accordianTouched, accordianIndex, true);
                                            }
                                            else {
                                                let checkValueForSelectedPart = [...this.props.checkAll];
                                                let { questionCheck = {} } = checkValueForSelectedPart[accordianIndex];
                                                let cloneQuestionCheck = { ...questionCheck };
                                                cloneQuestionCheck && Object.keys(cloneQuestionCheck).map((key: any) => {
                                                    cloneQuestionCheck[key] = false;
                                                });
                                                checkValueForSelectedPart[accordianIndex] = {
                                                    ...checkValueForSelectedPart[accordianIndex],
                                                    isSelected: false,
                                                    questionCheck: { ...cloneQuestionCheck }
                                                };
                                                this.props.selectAllCheckbox({
                                                    item: [...checkValueForSelectedPart]
                                                })
                                                this.HandleSelectAll(accordianTouched, accordianIndex, false);
                                            }
                                            this.props.setSelectAll({
                                                item: { ...this.props.selectAll, [`ACC${accordianIndex}`]: !this.props.selectAll[`ACC${accordianIndex}`] }
                                            })
                                        })
                                    // this.state.selectAll ? this.setState({checkAll: { ...this.state.checkAll, [`ACC${accordianIndex}`]: !this.state.checkAll[`ACC${accordianIndex}`] } }) :
                                    // this.setState({checkAll: { ...this.state.checkAll, [`ACC${accordianIndex}`]: this.state.checkAll[`ACC${accordianIndex}`] } }) 
                                }}
                            //inputProps={{ 'aria-label': 'checkbox with default color' }}
                            />&nbsp;&nbsp;
                            {!this.state.selectAll && !this.state.questionTabDetails.length ? 'Select All' : (this.state.questionTabDetails.length ?
                                this.state.questionTabDetails.length :
                                this.state.selectedQuestionsBySelectAllCount
                            )}{this.state.selectAll || this.state.questionTabDetails.length ? ' Selected' : ''}

                        </Grid>
                    )
                }
                <Grid item>
                    {
                        (this.props.selectAll[`ACC${accordianIndex}`] || (this.props.checkAll[accordianIndex] && this.props.checkAll[accordianIndex]['isSelected'])) ?
                            <Button variant="outlined" style={{ 'color': '#21A67A', 'border': '1px solid #21A67A', 'margin-bottom': '15px' }} onClick={() => {
                                this.importQuestion(contentRequestItemsId, questionId, questionCode, questionData, passage, this.props.totalUnresolvedCount);
                                this.setState({ contentRequestItemsId, selectAllCheck: !this.state.selectAllCheck })
                            }} >
                                <img src="/assets/svg/upload-icon.svg" />&nbsp;Bulk Import </Button>

                            : <>
                                <span>
                                    <img src="/assets/svg/infoIcon/info.svg" alt="info" />&nbsp;
                                    {/* <CustomInfoIcon
                                        infoDialogContentType="You can bulk import multiple questions from the library"
                                        isCenterArrow={true}
                                        isRightArrow={false}
                                        isInfoIcon={true}
                                        knowMoreAbout={false}
                                        dialogTitle="Bulk import"
                                        imageURL="/assets/svg/infoIcon/createQuestion/math.svg"
                                        dialogPara="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
                                        details="Click to know more"
                                        toolTipDirection="top" /> */}
                                </span>
                                <span style={{ 'font-size': '14px', 'color': '#666666' }}>You can bulk import multiple Questions from the Library</span>
                            </>
                    }
                </Grid>
            </Grid>
        )
    }

    contentChanged(contentId: string, numberValue: number, type: string, fromURL: string) {
        this.setState({
            selectedContentId: contentId,
            currentQuestionNumber: numberValue,
            fromURL: fromURL
        })
    }

    closeReviewContainer() {
        const { contentRequestData } = this.props;
        this.setState({
            showRequestContainer: false,
            sliderData: {},
            selectedContentId: '',
            currentQuestionNumber: 1,
            currentTestNumber: 1,
            fromURL: 'preview',
        }, ()=>{
                    this.props.setFeedbackClose({ booleanValue: true })
                    this.props.history.push(`/contentRequest/owner-task/${contentRequestData._id}/creator`);

        })

    }
    handleStatusOfQuestion(length: number, count: number) {
        let status: any;
        const { overallDone } = this.props;
        if (length === count && overallDone) {
            status = StepStatus.DONE;
        } else if (length !== 0) {
            status = StepStatus.INPROGRESS;
        } else {
            status = StepStatus.PENDING;
        }
        return status;
    }

    render = () => {
        const { accordianState, subHeading,
            contentRequestId, progressBarForQuestion, overallDone, classes } = this.props;
        const { showRequestContainer, sliderData, selectedContentId, currentQuestionNumber,
            currentTestNumber, contentQuestionCode, contentQuestionType, fromURL, loading } = this.state;
        const { totalCount, count } = progressBarForQuestion;
        const percentage = (count / totalCount) * 100;
        this.props.contentRequestData, contentRequestId;
        const previousOverAllData = localStorage.getItem('overallData')
        return (
            <>
                {this.state.loading ?
                    <MyPATLocalLoader /> :
                    <>
                        {
                            accordianState && accordianState.map((question: any, index: number) => {
                                const { accordianTouched = [] } = this.props;
                                const { type = '', count = 0, code = '', contentRequestItemsId = null } = question;
                                const { questionContent = [] } = accordianTouched[index];
                                const filterContent = questionContent.filter((ele: any) => ele.attachedQuestions.isJobCompleted)
                                const { passage = [] } = accordianState[index];
                                let syllabus = getSyllabusRenderValue(question);
                                let description = `${_.get(this.props.accordianState[index], 'description', 'N/A')} `
                                let totalUnresolvedFeedbackCount = _.get(this.props.accordianState[index], 'contentRequestItemsId.totalUnresolvedFeedbackCount', 0)

                                return (
                                    // <>
                                    <MyPATExpansionStep
                                        status={this.handleStatusOfQuestion(filterContent.length, count)}
                                        title={type}
                                        subHeading={`${count} Question`}
                                        secondarySummaryHeading="Syllabus"
                                        secondarySummary={syllabus}
                                        expanded={true}
                                        description={description !== " " ? description : 'N/A'}
                                        taskStatus={!filterContent.length ? true : false}
                                        isProgressReq={filterContent.length ? true : false}
                                        overallDone={overallDone}
                                        onFeedbackClickFromCreator={() => this.onFeedbackClickFromCreator(question)}
                                        countProgress={filterContent.length}
                                        totalCountProgress={count}
                                        percentage={((filterContent.length / count) * 100).toFixed(2)}
                                        totalUnresolvedFeedbackCount={totalUnresolvedFeedbackCount - (this.props.removeUnresolvedFeedbackCount[`acc${index}`] ? this.props.removeUnresolvedFeedbackCount[`acc${index}`] : 0)}
                                    //status={StepStatus.PENDING} title={type} subHeading={`${count} Question`} secondarySummary="Syllabus: Triple Integration & Spacial calculation & Parabola" thirdSummary="Status: Not Started yet" expanded={false}
                                    >
                                        {/* <div> */}
                                        <Grid>
                                            {!(filterContent.length === count) && !this.props.isTestRequest && this.bulkImportButton(contentRequestItemsId, this.props.accordianTouched, index, question._id, code, question, passage)}
                                            {/* {!this.props.isTestRequest && this.bulkImportButton(contentRequestItemsId, this.props.accordianTouched, index, this.props.accordianCreateTouched.questionIndex)} */}
                                            {/* {!this.props.isTestRequest && this.bulkImportButton(contentRequestItemsId, this.props.accordianTouched, index, this.props.accordianCreateTouched.questionIndex)} */}
                                        </Grid>
                                        <Grid>
                                            {this.addQuestions(count, code, index, contentRequestItemsId, question._id, question)}
                                        </Grid>
                                        {/* </div> */}

                                    </MyPATExpansionStep>

                                    // </>
                                )
                            })
                        }
                        <SelectWithContent
                            selectAllCheck={this.state.selectAllCheck}
                            HandleSelectAll={() => { this.HandleSelectAll }}
                            selectAll={this.state.selectAll}
                            selectAllData={this.state.selectAllData}
                            accordianBulkIndex={this.state.accordianBulkIndex}
                            contentRequestQuestionId={this.state.questionId}
                            preSelectedFilterContent={this.state.preSelectedFilterContent}
                            contentRequestItemsId={this.state.contentRequestItemsId}
                            selectQuestionDialogOpen={this.state.selectQuestionDialogOpen}
                            handleChooseFromLibrary={this.handleChooseFromLibrary}
                            accordianCreateTouched={this.state.accordianCreateTouched}
                            contentRequestId={this.props.contentRequestData._id}
                            questionCode={this.state.code}
                            passage={this.state.passage}
                            isUnresolvedCount={this.state.isUnresolvedCount}
                            handleChooseFromLibraryForUnresolvedContent={this.handleChooseFromLibraryForUnresolvedContent}
                            unresolvedFeedbackCount={this.state.unresolvedFeedbackCount}
                        />
                        {showRequestContainer &&
                            <Modal
                                open={true}
                                classes={{ root: classes.fullModal }}
                                aria-labelledby="simple-modal-title"
                                aria-describedby="simple-modal-description"
                                hideBackdrop={true}
                            >
                                <RequestReviewContainer contentRequestId={this.props.contentRequestData._id} contentId={selectedContentId}
                                    sliderData={sliderData} currentQuestionNumber={currentQuestionNumber}
                                    contentChanged={this.contentChanged} closeReviewContainer={this.closeReviewContainer}
                                    authorType={'creator'}
                                    currentTestNumber={currentTestNumber} contentQuestionType={contentQuestionType}
                                    contentQuestionCode={contentQuestionCode}
                                    fromURL={fromURL} />
                            </Modal>
                        }
                    </>
                }
            </>
        )
    }


}
const mapStateToProps = (state: any) => ({
    accordianState: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianState', []),
    accordianTouched: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianTouched', []),
    accordianCreateTouched: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianCreateTouched', []),
    isComingFromQuestionComponent: _.get(state, 'contentRequestData.contentRequestAccordianData.isComingFromQuestionComponent'),
    isTabOpened: _.get(state, 'contentRequestData.contentRequestAccordianData.isTabOpened'),
    progressBarForQuestion: _.get(state, 'contentRequestData.contentRequestAccordianData.progressBarForQuestion', {}),
    accordianTest: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianTest', []),
    bulkImportCount: _.get(state, 'bulkImportCount.count', {}),
    selectedQuestionsBySelectAll: _.get(state, 'bulkImportCount.selectedQuestionsBySelectAll', {}),
    manuallySelectedBulkQuestions: _.get(state, 'bulkImportCount.questionTabDetails', {}),
    filteredQuestionArray: _.get(state, 'contentRequestData.contentRequestAccordianData.filteredQuestionArray', []),
    contentRequestItemsIdForFirstTime: _.get(state, 'contentRequestData.contentRequestAccordianData.contentRequestItemsIdForFirstTime'),
    getGoals: _.get(state, 'testTemplate.goal.list', []),
    getSubjects: _.get(state, 'testTemplate.subject.list', []),
    selectAll: _.get(state, 'bulkImportCount.selectAll', {}),
    checkAll: _.get(state, 'bulkImportCount.checkAll', []),
    questionTabDetails: _.get(state, 'bulkImportCount.questionTabDetails', []),
    removeUnresolvedFeedbackCount: _.get(state, 'contentRequestData.contentRequestAccordianData.removeUnresolvedFeedbackCount', {})
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    setAccordianState: contentRequestAccordianActions.setAccordianState,
    setAccordingTouchIndex: contentRequestAccordianActions.setAccordingTouchIndex,
    setAccordianTouchWhileCreate: contentRequestAccordianActions.setAccordianTouchWhileCreate,
    setIsTabOpened: contentRequestAccordianActions.setIsTabOpened,
    setProgressBarForQuestion: contentRequestAccordianActions.setProgressBarForQuestion,
    setTestAccordian: contentRequestAccordianActions.setTestAccordian,
    selectAllCheckbox: selectAllCheckbox,
    setSelectAll: setSelectAll,
    setQuestionTabDetails: setQuestionTabDetails,
    setFilterQuestionArray: contentRequestAccordianActions.setFilterQuestionArray,
    setSelectedQuestionsBySelectAll,
    showMsg: showMsg,
    setResetQuestionsBySelectAll,
    getTypeOfGoal,
    getSubject,
    setFeedbackClose: contentRequestAccordianActions.setFeedbackClose,

}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
    // @ts-ignore
)(withRouter(withStyles(userStyles)(QuestionComponent)));
